import { actions } from './slice';
import { getUser, createAdmin, createUser } from './action';

const allActions = {
  ...actions,
  getUser,
  createAdmin,
  createUser,
};

export { allActions as userActions };
export { reducer as userReducer } from './slice';
